export class ClientNotLoadedError extends Error {
  public constructor(message?: string) {
    super(message);
  }
}
